// extracted by mini-css-extract-plugin
export default {"link":"aw4kcY","image":"WfHCnG","root":"rhY5T2"};